function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#FFFFFF;}\n");

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M264.2,43c-15.9-18-35.9-27.7-59.9-29.1c-10.7-0.6-21.2,1-31.4,4.4c-10.7,3.6-20.4,9.1-29.1,16.4 c-0.3-0.2-0.5-0.4-0.7-0.6c-0.2-0.2-0.5-0.4-0.7-0.6C129.6,23.2,115.4,16.3,99.2,14c-4.2-0.6-8.4-0.9-12.6-0.7 c-6.5,0.3-12.8,1.5-19.1,3C50.6,20.2,36,28.3,24.3,41C10.7,55.6,3.5,73.1,2,92.9c-0.7,8.9,0.2,17.7,2.3,26.4 c3.8,16.1,12.4,29.4,23,41.6c36.8,36.8,73.5,73.7,110.3,110.5c3.2,3.2,8,3.2,11.2,0c24.1-24,48.2-48.1,72.3-72.1 c13.2-13.2,26.6-26.1,39.6-39.5c20-20.7,27.7-45.7,23.4-74.1C281.7,69.5,275,55.2,264.2,43z M251.5,147.1c-1,1.1-2.1,2.2-3.1,3.3 C213.6,185,178.8,219.7,144,254.4c-0.2,0.2-0.4,0.5-0.9,1c-0.3-0.5-0.5-0.8-0.8-1.1C107.8,219.7,73.2,185,38.6,150.5 c-10.2-10.2-17.3-22.2-20.2-36.3C14,92.2,18.7,72.3,32.6,54.8C43.4,41.3,57.5,33,74.5,29.6c6.2-1.2,12.5-1.5,18.8-1 c11.4,0.8,21.9,4.3,31.6,10.2c4.7,2.9,9,6.3,12.9,10.2c3.3,3.4,8,3.3,11.4,0c10.6-10.3,23.1-17,37.7-19.4 c20.4-3.4,39,1.1,55.5,13.7c14.5,11.1,23.6,25.8,26.6,43.8C272.7,109.8,266.8,129.8,251.5,147.1z"
}));

var SvgHeart = function SvgHeart(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 287 286.9",
    style: {
      enableBackground: "new 0 0 287 286.9"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHeart, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/heart.4f9a2229.svg";
export { ForwardRef as ReactComponent };